import { action } from 'satcheljs/lib/legacy';
import store from '../store/store';
import MailboxCalendarConfiguration from 'owa-service/lib/contract/MailboxCalendarConfiguration';

let assign = require('object-assign');

export default action('storeCalendarMailboxConfiguration')(
    async function storeCalendarMailboxConfiguration(
        mailboxCalendarConfiguration: MailboxCalendarConfiguration
    ) {
        assign(store.calendarConfiguration, mailboxCalendarConfiguration);
    }
);
